export default __webpack_public_path__ + "static/media/SafariRay1.9e4e63d5.jpg";